import { render, staticRenderFns } from "./riskList.vue?vue&type=template&id=c8dd5f36&scoped=true"
import script from "./riskList.vue?vue&type=script&lang=js"
export * from "./riskList.vue?vue&type=script&lang=js"
import style0 from "./riskList.vue?vue&type=style&index=0&id=c8dd5f36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dd5f36",
  null
  
)

export default component.exports